import React from 'react';
import autoBind from 'react-autobind';

import * as Components from '../Components.js';
//import * as Generation from '../Generation.js';
// import * as Helpers from '../Helpers.js';

//import the Darwin API classes
import API from '../API.js';

//import * as ExampleData from '../data/exampleData.json'

// import ImageHomePage from '../images/Floww/HomePage.png'
// import ImageReadyToFlow from '../images/Floww/Ready to Floww.jpg'
// import ImageYoga3 from '../images/Floww/HomeYoga3.png'

export class Home extends React.Component {

  constructor(props) {
    super(props)

    let data = {}

    this.state = {
      loading: false,
      data: data,
      forceCheck: false,
      shakeButton: false,

      view: "Home",
      subview: "Home",
      abilities: [],
      actions: [],
    }
    autoBind(this)
  }

  componentDidMount() {
    this.calculateView()
  }

  componentDidUpdate(prevProps) {
    if (this.props.render !== prevProps.render) {
      //reload the home view.
      this.calculateView()
    }
  }

  /*
  * Loads the abilites for this user.
  */
  getAbilities() {
    this.setState({
      loading: true
    }, () => {
      if (API.checkingAuth) {
        //delay 1s to recall this function.
        setTimeout(this.getAbilities, 1000)
        return
      }
      API.callDarwinAPI("GET", "abilities", {}, async (result) => {
        console.log("abilities", result)
        if ("error" in result) {
          //Change the view to 404
          this.props.showPopup("Error", "Couldn't get abilities", "Please try again. If this continues to occur, reach out to support@geoji.com")
          this.setState({
            loading: false
          })
          return
        }
        this.setState({
          loading: false,
          abilities: result.data.abilities,
          actions: result.data.actions || [],
        })
      })
    })
  }

  calculateView() {
    if (this.state.view === "Home") {
      //load the abilities for this user.
      this.getAbilities()
    }
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure we have all of the data.
    let valid = true
    let requiredFields = []
    let requiredIf = []
    let requiredSometimes = [] //if set, then don't remove it from the data.
    let optionals = [] //the optional fields apart from the requiredFields.
    switch (this.state.view) {
      case "Home":
        requiredFields = []
        optionals = []
        requiredIf = []
        requiredSometimes = []
        break;
      default:
        break;
    }
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        //the field is not filled out
        console.log("required not filled out: ", element)
        valid = false
      }
    })
    requiredIf.forEach((condition) => {
      if (this.state.data[condition.field] === undefined || this.state.data[condition.field].value === undefined) {
        //the condition field is not filled out
        console.log("condition field is not filled out: ", condition)
        valid = false
      } else if (condition.values !== undefined && condition.values.includes(this.state.data[condition.field].value)) {
        //this field is required
        if (this.state.data[condition.require] === undefined || this.state.data[condition.require].value === undefined) {
          //and is not filled out
          console.log("rif field is required and is not filled out: ", condition)
          valid = false
        }
      } else if (condition.not !== undefined && !condition.not.includes(this.state.data[condition.field].value)) {
        //this field is required
        if (this.state.data[condition.require] === undefined || this.state.data[condition.require].value === undefined) {
          //and is not filled out
          console.log("rif field is required with not and is not filled out: ", condition)
          valid = false
        }
      }
    })
    //2) Make sure every data element is valid.
    for (let key in this.state.data) {
      let forget = false
      //Make sure it is not a requiredSometimes
      if (!requiredSometimes.includes(key)) {
        // Check the requiredIf conditions
        for (let i = 0; i < requiredIf.length; i = i + 1) {
          let rif = requiredIf[i]
          if (rif.require === key) {
            if (!rif.values.includes(this.state.data[rif.field].value)) {
              if (rif.not === undefined || rif.not.includes(this.state.data[rif.field].value)) {
                forget = true
              }
            }
            break
          }
        }
      }
      //Make sure this is a field we are looking for.
      if (optionals.includes(key) || requiredFields.includes(key)) {
        if (!forget && this.state.data[key].valid === false) {
          console.log("data not valid", key)
          valid = false
        }
      }
    }

    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        let forget = false
        //Make sure it is not a requiredSometimes
        if (!requiredSometimes.includes(key)) {
          for (let i = 0; i < requiredIf.length; i = i + 1) {
            let rif = requiredIf[i]
            if (rif.require === key) {
              if (!rif.values.includes(this.state.data[rif.field].value)) {
                if (rif.not === undefined || rif.not.includes(this.state.data[rif.field].value)) {
                  forget = true
                }
              }
              break
            }
          }
        }
        if (!forget) {
          if (optionals.includes(key) || requiredFields.includes(key)) {
            if (this.state.data[key].value !== false && this.state.data[key].value.toString().length > 0) {
              data[key] = this.state.data[key].value
              if (typeof data[key] === 'string') {
                data[key] = data[key].trim()
              }
            }
          }
        }
      }
      //Submit the form
      switch (this.state.view) {
        case "Home":
          //this.updateFees(data)
          break;
        default:
          break;
      }
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d,
        forceCheck: false
      }
    }, () => {
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  /*
  Changes the view to this selected ability.
  */
  openAbility(ability) {
    this.props.changeView(ability.view)
  }

  /*
  Changes the view to this selected action.
  */
  openAction(action) {
    //ManageUsers - RequestedPayout
    //ManageDisputes
    this.props.changeView(action.view, action.subview)
  }

  render() {

    return (
      <div className="Home">
        { this.state.loading &&
          <div className="PortalCenterCenter">
            <div className="PortalCenterCenterContent">
              <Components.LoadingIndicator color="dark" />
            </div>
          </div>
        }
        { !this.state.loading &&
          <div className="HomeTopSection">
            <div className="HomeTopSectionContent">
              <div className="HomeTopSectionTitle">
                Geoji
              </div>
              <div className="HomeTopSectionTitleBold">
                Admin
              </div>
              <div className="HomeTopSectionDescription">
                Welcome & create
              </div>
              <div className="HomeTopSectionDescription">
                something amazing
              </div>
              <div className="HomeTopSectionHeader">
                Actions
              </div>
              <div className="HomeTopSectionActions">
                { this.state.actions.length === 0 &&
                  <div className="HomeTopSectionActionsNone">
                    No actions to take at this time.
                  </div>
                }
                { this.state.actions.map((action, i) => (
                  <div className="HomeTopSectionAction" onClick={this.openAction.bind(this, action)} key={"action_" + i}>
                    <div className="HomeTopSectionActionName">
                      {action.name}
                    </div>
                    <div className="HomeTopSectionActionDescription">
                      {action.description}
                    </div>
                  </div>
                ))}
              </div>
              <div className="HomeTopSectionHeader">
                Abilities
              </div>
              <div className="HomeTopSectionAbilities">
                { this.state.abilities.map((ability, i) => (
                  <Components.GeojiButton type="Dark" onClick={this.openAbility.bind(this, ability)} key={"ability_" + i}>
                    {ability.name}
                  </Components.GeojiButton>
                ))}
              </div>
              { this.state.abilities.length === 0 &&
                <div className="HomeTopSectionNoAbilities">
                  You have not been granted access. Please reach out to your manager to get access.
                </div>
              }
            </div>
          </div>
        }
      </div>
    )
  }
}
